import Vue from "vue";
import Auth from "./Auth.vue";
import Default from "./Default.vue";
import Base from "./Base.vue";
Vue.component("auth-layout", Auth);
Vue.component("default-layout", Default);
Vue.component("base-layout", Base);
